<script lang="ts" setup generic="T extends GenericObject">
import { provide } from 'vue';
import { CELL_CONTEXT } from '../shared';
import type { GenericObject } from '../../../../shared/types';
import type { UiDataTableColumn } from '../interfaces';
type Row = T;
type Column = UiDataTableColumn<T>;
interface Props {
  column?: Column;
  row?: Row;
  value?: string;
  rawValue?: any;
}
const props = defineProps<Props>();
provide(CELL_CONTEXT, {
  align: props.column?.align ?? 'start',
  monospace: props.column?.monospace ?? false,
  row: props.row,
  columnKey: props.column?.key,
  filterKey: props.column?.filterKey,
  filterValueGetter: props.column?.filterValueGetter as ((row: GenericObject) => unknown) | undefined,
  value: props.value ?? '',
  rawValue: props.rawValue,
});
</script>

<template>
  <div :class="$style.root">
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '../shared' as tableSharedStyles;

.root {
  position: relative;
  display: flex;
  box-sizing: border-box;
  width: auto;
  font-size: 13px;
  line-height: 16px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-right: 1px solid tableSharedStyles.$border-color;
    z-index: tableSharedStyles.$z-index-border;
    pointer-events: none;
  }
}
</style>
